module.exports = __webpack_public_path__ + "img/border_circularAndRight.d29c5478.svg";